import React from 'react';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';

/**
 * Composant label pour le nœud Survey
 */
const SurveyNodeLabel = ({ callFlowData, handleEditNode, handleDeleteNode }) => {
  const survey = callFlowData?.survey || {};
  const questionsCount = Object.keys(survey.questions || {}).length;
  const isEnabled = survey.enabled === true;

  return (
    <div
      className="node-survey"
      onClick={() => handleEditNode('survey')}
      style={{ cursor: 'pointer' }}
    >
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode('survey');
              }}
            >
              Éditer
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteNode('survey');
              }}
            >
              Supprimer
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>

      <div className="node-title">Survey</div>
      <div className="node-separator"></div>
      <div className="node-info">
        <div className="node-info-row">
          <span className="node-info-label">Status:</span>
          <span className={`node-info-value ${isEnabled ? 'enabled' : 'disabled'}`}>
            {isEnabled ? '✓ Enabled' : '✗ Disabled'}
          </span>
        </div>
        <div className="node-info-row">
          <span className="node-info-label">Questions:</span>
          <span className="node-info-value">{questionsCount}</span>
        </div>
        {survey.timeout && (
          <div className="node-info-row">
            <span className="node-info-label">Timeout:</span>
            <span className="node-info-value">{survey.timeout}s</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SurveyNodeLabel;
